import { render, staticRenderFns } from "./sbToolbarBtn.vue?vue&type=template&id=55257e74&scoped=true"
import script from "./sbToolbarBtn.vue?vue&type=script&lang=ts"
export * from "./sbToolbarBtn.vue?vue&type=script&lang=ts"
import style0 from "./sbToolbarBtn.vue?vue&type=style&index=0&id=55257e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55257e74",
  null
  
)

export default component.exports